import React from "react";

import { useIntl } from "react-intl";

import Handshake24 from "@/icons/__generated__/Handshake/Handshake24";
import HouseDamages24 from "@/icons/__generated__/HouseDamages/HouseDamages24";
import Security24 from "@/icons/__generated__/Security/Security24";

type TrustIntroBlockListItem = {
  id: string;
  trustIntroItemIcon: React.ReactNode;
  trustIntroItemTitle: string;
  trustIntroItemSubtitle: string;
  trustIntroItemDescription: string;
  trustIntroItemCaption?: string;
};

const useTrustIntroBlockList = (): TrustIntroBlockListItem[] => {
  const intl = useIntl();

  return [
    {
      id: "host_liability_insurance",
      trustIntroItemIcon: <Security24 aria-hidden />,
      trustIntroItemTitle: intl.formatMessage({
        defaultMessage: "Host liability insurance",
      }),
      trustIntroItemSubtitle: intl.formatMessage({
        defaultMessage: "Up to $1,000,000 per booking",
      }),
      trustIntroItemDescription: intl.formatMessage({
        defaultMessage:
          "Every Peerspace booking automatically includes up to $1M in supplemental general liability coverage, so you can host with confidence. ",
      }),
    },
    {
      id: "damage_guarantee",
      trustIntroItemIcon: <HouseDamages24 aria-hidden />,
      trustIntroItemTitle: intl.formatMessage({
        defaultMessage: "Damage guarantee",
      }),
      trustIntroItemSubtitle: intl.formatMessage({
        defaultMessage: "Up to $25,000 per booking",
      }),
      trustIntroItemDescription: intl.formatMessage({
        defaultMessage:
          "If a guest damages your space, you’re covered up to $25,000 – no chasing the guest for reimbursement. Your furniture, floors, equipment: all protected.",
      }),
      trustIntroItemCaption: intl.formatMessage({
        defaultMessage: "Available for US-based venues only.",
      }),
    },
    {
      id: "trust_safety",
      trustIntroItemIcon: <Handshake24 aria-hidden />,
      trustIntroItemTitle: intl.formatMessage({
        defaultMessage: "Trust & safety",
      }),
      trustIntroItemSubtitle: intl.formatMessage({
        defaultMessage: "Built into every transaction",
      }),
      trustIntroItemDescription: intl.formatMessage({
        defaultMessage:
          "A risk score is determined for every booking. Our dedicated Trust & Safety team reviews potentially suspicious behavior, and support is just a message away.",
      }),
    },
  ];
};

export { useTrustIntroBlockList };
